// src/app/modules/Members/pages/members-table/column-formatters/ActionsColumnFormatter.jsx
import React from "react";
import { Mail, XCircle, Edit2 } from "lucide-react";

export function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { onViewDetails, onEdit, onSuspend, onReactivate, onDelete, onResendInvite, onCancelInvite }
) {
  const isPending = row.status === 'pending';

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
      {isPending ? (
        <>
          <ActionBtn onClick={() => onResendInvite(row.membership_id)} title="Resend Invite">
            <Mail size={14} />
          </ActionBtn>
          <ActionBtn onClick={() => onCancelInvite(row.membership_id)} title="Cancel Invite" danger>
            <XCircle size={14} />
          </ActionBtn>
        </>
      ) : (
        onEdit && (
          <ActionBtn onClick={() => onEdit(row)} title="Edit">
            <Edit2 size={14} />
          </ActionBtn>
        )
      )}
    </div>
  );
}

function ActionBtn({ onClick, title, children, danger }) {
  return (
    <button
      type="button"
      className={`sety-btn ${danger ? 'sety-btn-danger' : 'sety-btn-ghost'}`}
      style={{ padding: '6px 10px' }}
      onClick={onClick}
      title={title}
    >
      {children}
    </button>
  );
}
